export default {
  title: '修改郵箱',
  submit: '確定',
  cencel: '取消',
  success: '修改郵箱成功,將跳轉至登錄頁面',
  sendSuccess: '郵件發送成功',
  error: {
    0: '驗證碼已過期',
    1: '驗證碼不正確',
    2: '新郵箱地址不能跟舊郵箱地址相同',
    3: '郵箱格式不正確'
  },
  getCode: '獲取驗證碼',
  newTip: `請輸入您要綁定的郵箱地址，更換後您可以通過新的郵箱登錄和找回密碼。 `,
  oldTip: `點擊獲取驗證碼我們將發送郵件到{0}的郵箱中。 `,
  code: `請填寫驗證碼`,
  reset: `重新獲取`,
  showTip1: `您的驗證碼已發送到{0}郵箱中,請前往郵箱查看驗證碼`,
  showTip2: `您的驗證碼已發送到{0}郵箱中<a target='_blank' href='{1}'>點此進入</a>`

}
